
<div class="flow-dropdown-menu-wrapper">
	<div class="flow-dropdown-menu-trigger">
		<slot name="trigger" />
	</div>
	<div class="flow-dropdown-menu" :style="{ width: width + 'px' }" :open="open">
		<slot />
	</div>
</div>
